"use client";

import { cn } from "@/lib/utils";
import { Input } from "@/ui/shadcn/input";
import { type ComponentPropsWithRef, useState } from "react";

/**
 * Sometimes, when form is submitted (server action), the input values are reset.
 * This component keeps a copy of the input value in the component state to prevent this.
 * Honestly speaking, I don't know why this happens. Didn't want to waste time debugging it.
 * When we fix the issue, we can remove this component. - Michał
 */
export const StatefulInput = ({
	value,
	onChange,
	defaultValue,
	onValueChange,
	...props
}: ComponentPropsWithRef<typeof Input> & {
	onValueChange?: (value: string) => void;
}) => {
	const [state, setState] = useState(value || defaultValue || "");

	return (
		<Input
			{...props}
			value={state}
			className={cn("bg-white", props.className)}
			onChange={(e) => {
				setState(e.currentTarget.value);
				onChange?.(e);
				onValueChange?.(e.currentTarget.value);
			}}
		/>
	);
};
